interface Props {
  [key: string]: any
}

export default function ArrowDownThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 17 24" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M9.36905 22.7281L15.986 16.6454C16.3462 16.3142 16.3486 15.7751 15.9914 15.4408L14.6903 14.2231C14.3331 13.8888 13.7519 13.8862 13.3916 14.2173L6.77412 20.3006C6.4139 20.6317 6.41149 21.1708 6.76874 21.5051L8.0698 22.7228C8.42706 23.0566 9.00882 23.0592 9.36905 22.7281Z"
        fill="#A840C8"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M10.4072 1.07518L10.3144 21.8608L6.51354 20.5624L6.60066 1.05818C6.60277 0.58666 6.92423 0.205406 7.31821 0.207166L9.69731 0.217793C10.0913 0.219553 10.4093 0.603665 10.4072 1.07518Z"
        fill="#A840C8"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M8.06835 22.721L0.952123 16.0605C0.594871 15.7262 0.597279 15.1871 0.957504 14.856L2.26939 13.65C2.62961 13.3189 3.21083 13.3215 3.56808 13.6558L10.6754 20.308L10.67 21.5296L9.36703 22.7273C9.00737 23.0579 8.4256 23.0553 8.06835 22.721Z"
        fill="#A840C8"
      />
    </svg>
  )
}
